import ApiClient from "@/api/v2/base";
import route from "@/bundles/route";

class NotificationsApi extends ApiClient {
    getNotifications(page, limit, days = 0, unread = false) {
        const url = route("api.v2.notifications.list");

        return this.getAuthenticated(url, {
            params: {
                page: page,
                limit: limit,
                days: days,
                unread: unread,
            },
        });
    }

    deleteNotification(id) {
        const url = route("api.v2.notifications.delete", { id: id });

        return this.deleteAuthenticated(url);
    }

    markRead(ids) {
        const url = route("api.v2.notifications.mark-read");

        return this.postAuthenticated(url, {
            ids: ids,
        });
    }
}

const api = new NotificationsApi();

export default api;
